import { createModelPermissions } from 'components/permissions/utils/model-permission-generator';

const SupplierConst = createModelPermissions({
  modelName: 'suppliers',
  basePath: '/suppliers',
  permissions: {
    VIEW: true,
    UPDATE: true,
    DELETE: true,
    IMPORT: true,
  }
});

export default SupplierConst;